import {
  WEB_COMPONENT_POLICY_PANEL_RELAY_COMMUNICATION_WHITELIST_ITEM
} from '../../../../../../../webcomponents.constants';
import {
  GzPolicyUiSettingsGridItemFormWebComponent
} from '../../../../../../common/policyPanel/uiSettings/gridTemplate/form';
import { customElement, query } from 'lit/decorators.js';
import { GzFormFieldWebComponent } from '../../../../../../../ui/gzForm/formField';
import { GzInputWebComponent } from '../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { html, TemplateResult } from 'lit';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { FormGroup } from '../../../../../../../ui/gzForm/formGroup/form-group';
import { InputWidthValues } from '../../../../../../../ui/gzInput';
import { domainsValidator } from '../utils/validators';

@customElement(WEB_COMPONENT_POLICY_PANEL_RELAY_COMMUNICATION_WHITELIST_ITEM)
export class GzRelayCommunicationWhitelistItemFormWebComponent extends GzPolicyUiSettingsGridItemFormWebComponent {
  @query('#whitelistDomain')
  whiteListDomainItem: GzFormFieldWebComponent<GzInputWebComponent, string>;

  public setError(error: string) {
    this.whiteListDomainItem.setError(error);
  }

  renderFormFields(): TemplateResult {
    return html`
      <div class="policy-grid-item-form--field">
        <gz-form-field id="whitelistDomain">
          <gz-input
            gz-form-input
            inputWidth="${InputWidthValues.XXLARGE}"
            label="${translateFn('Domain')}"
            placeholder="${translateFn('Domain')}"
          ></gz-input>
        </gz-form-field>
      </div>
    `;
  }

  focusFirstInput(): void {
    this.whiteListDomainItem.Input.inputFocus();
  }

  createFormGroup(): void {
    this.setFormFieldValidators();

    this.formGroup = new FormGroup({
      name: this.whiteListDomainItem,
    });
  }

  setFormFieldValidators(): void {
    this.whiteListDomainItem.Validators = domainsValidator();
  }

  resetForm(): void {
    this.whiteListDomainItem.value = '';
    this.whiteListDomainItem.resetField();
  }

  reset() {
    this.resetForm();
  }

  resetOnAdd() {
    this.resetForm();
  }
}
